import React from 'react';
import PropTypes from 'prop-types';
import { Video as SashVideo } from '@pella/sash-framework';

const Video = ({ data, className }) => {
	const videoImage = data?.image_overlay?.[0]?.file?.url || data?.image_overlay?.[0]?.image?.url || null;

	return (
		<div className={`pd-video ${className || ''}`}>
			<SashVideo
				title={data.video_title}
				source={data.video_id}
				transcript={data.transcript}
				poster={videoImage ? videoImage + '?format=pjpg&auto=webp' : null}
			/>
		</div>
	);
};

Video.propTypes = {
	data: PropTypes.object.isRequired,
	className: PropTypes.string,
};

export default Video;
